import { Icon } from "@iconify/react";
import { Container, SectionHeading } from "./primitives";

const STEPS = [
  {
    icon: "lucide:cloud-upload",
    title: "Upload or Connect",
    body: "Add your records by uploading files or connecting your hospital portal directly. Supports any format, any source.",
  },
  {
    icon: "lucide:cpu",
    title: "We Read & Verify",
    body: "AI extracts clinical data and flags anything uncertain for human review before it ever reaches your dashboard. Verified hospital data always takes priority.",
  },
  {
    icon: "lucide:chart-no-axes-column",
    title: "See Your Health, Clearly",
    body: "Your records become an organized, readable dashboard of medications, labs, diagnoses, and imaging, all in plain language.",
  },
];

export function HowItWorksSection() {
  return (
    <section id="how-it-works" className="scroll-mt-[68px] bg-[#F8F9FB] pt-[88px] pb-20 lg:pt-[110px] lg:pb-[104px]">
      <Container>
        <SectionHeading eyebrow="How it works" title="From scattered records to clear health picture" />

        <ol className="relative mx-auto !mt-16 grid max-w-[1152px] gap-12 md:grid-cols-3 md:gap-6">
          {/* Connector line behind the step tiles (center of first to center of last). */}
          <span aria-hidden="true" className="absolute left-[16.66%] right-[16.66%] top-7 hidden h-px bg-[#ECEDF2] md:block" />
          {STEPS.map((step, i) => (
            <li key={step.title} className="relative flex flex-col items-center text-center">
              <span className="relative flex h-14 w-14 items-center justify-center rounded-[14px] bg-[#0A2947] shadow-[0_8px_18px_rgba(10,41,71,0.22)]">
                <Icon icon={step.icon} className="h-[22px] w-[22px] text-white" />
                <span className="absolute -right-2.5 -top-2 flex h-5 w-5 items-center justify-center rounded-full bg-[#EB7A91] text-[10px] font-bold text-white shadow-[0_2px_6px_rgba(235,122,145,0.45)]">
                  {i + 1}
                </span>
              </span>
              <p className="!mt-[22px] text-[11px] font-bold tracking-[0.12em] text-[#6B7280]">
                STEP {String(i + 1).padStart(2, "0")}
              </p>
              <h3 className="!mt-2.5 text-[18px] font-extrabold tracking-[-0.02em] text-[#120240]">{step.title}</h3>
              <p className="!mt-3 max-w-[255px] text-[14px] leading-6 text-[#4B5563]">{step.body}</p>
            </li>
          ))}
        </ol>
      </Container>
    </section>
  );
}
